import { render, staticRenderFns } from "./CenterComponent.vue?vue&type=template&id=aaa82b82&scoped=true"
import script from "./CenterComponent.vue?vue&type=script&lang=js"
export * from "./CenterComponent.vue?vue&type=script&lang=js"
import style0 from "./CenterComponent.vue?vue&type=style&index=0&id=aaa82b82&prod&lang=scss&scoped=true"
import style1 from "./CenterComponent.vue?vue&type=style&index=1&id=aaa82b82&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa82b82",
  null
  
)

export default component.exports